import type { PropsWithChildren } from "react"
import React from "react"
import type { ChildComponentProps } from "google-map-react"
import { Popover, PopoverTrigger, PopoverContent } from "@chakra-ui/react"
import {
    useIsDarkMode,
    ContrastPillButton,
    componentStyles,
} from "@mallardbay/lib-react-components"

interface Props extends ChildComponentProps, PropsWithChildren {
    readonly label: string
}

export default function MapMarker({ label, children }: Props) {
    const styles = useStyles()
    const isDarkMode = useIsDarkMode()
    // This keeps it always black which we need because our map is always light
    const isInverted = !isDarkMode

    return (
        <Popover closeOnBlur>
            <PopoverTrigger>
                <ContrastPillButton isInverted={isInverted}>
                    {label}
                </ContrastPillButton>
            </PopoverTrigger>
            <PopoverContent style={styles.popoverContent}>
                {children}
            </PopoverContent>
        </Popover>
    )
}

function useStyles() {
    return componentStyles({
        popoverContent: {
            height: "300px",
            width: "200px",
            backgroundColor: "transparent",
        },
    })
}
